import { render } from "./ModalTerms.vue?vue&type=template&id=6a46f683&scoped=true"
import script from "./ModalTerms.vue?vue&type=script&lang=js"
export * from "./ModalTerms.vue?vue&type=script&lang=js"

import "./ModalTerms.vue?vue&type=style&index=0&id=6a46f683&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a46f683"]])

export default __exports__